import HomeRoutes from "./home";
import PublicRoutes from "./public";
import CategoryRoutes from "./category-management";
import UserRoutes from "./user-management";
import ArticleRoutes from "./article-management";
import Escrow from "./escrow";
import TransactionRoutes from "./transaction-history";
import NotFoundRoute from "./notFound";
import ReviewRatingRoutes from "./review-rating-management";
import SettingsRoutes from "./settings"
import StoreManagementRoutes from "./store-management";

const Routes = [
  ...PublicRoutes,
  ...HomeRoutes,
  ...CategoryRoutes,
  ...StoreManagementRoutes,
  ...UserRoutes,
  ...ArticleRoutes,
  ...Escrow,
  ...TransactionRoutes,
  ...ReviewRatingRoutes,
  ...SettingsRoutes,
  ...NotFoundRoute,
];
export default Routes;
